import howler from 'howler';

const AudioManager = {
	install(Vue, options) {
		let sounds = {};
		
		Vue.loadAudio = (name, url , successCallback , failCallback) =>{
			let sound = new Howl({
				src: [url],
				buffer: false,
				autoplay: false,
				//html5: true,
				onloaderror: (e)=>{
					if(failCallback != undefined) failCallback(e);
				},
				onload: ()=>{
					sounds[name] = sound;
					if(successCallback != undefined) successCallback();
				}
			});
			
		};
		
		Vue.unloadAudio = (name) =>{
			let sound = sounds[name];
			if(sound == null || sound == undefined) return;
			if(sound.playing()) sound.stop();
			delete sounds[name];
		};
		
		Vue.getAudio = (name, settings) =>{
			let sound = sounds[name];
			if(sound == null || sound == undefined){
				console.log("Audiomanager doesnt contain a sound called: " + name);
				return null;
			}
			
			if(settings != undefined && settings != null){
				sound.volume(settings.volume || 1);
				sound.loop(settings.loop || false);
			}
			else{
				sound.volume(1);
				sound.loop(false);
			}
			
			return sound;
		};
		
		Vue.playAudio = (name , settings) =>{
			let sound = sounds[name];
			if(sound == null || sound == undefined){
				console.log("Audiomanager doesnt contain a sound called: " + name);
				return null;
			}
			
			if(settings != undefined && settings != null){
				sound.volume(settings.volume || 1);
				sound.loop(settings.loop || false);
			}
			else{
				sound.volume(1);
				sound.loop(false);
			}
			
			if(sound.playing()) sound.seek(0);
			else sound.play();
			return sound;
		}
		
		Vue.stopAll = () =>{
			for (let sound in sounds) {
				if (Object.prototype.hasOwnProperty.call(sounds, sound)) {
					if(sound == null || sound == undefined){
						continue;
					}
					if(sound.playing) sound.stop();
				}
			}
		}
		
	}
};

export default AudioManager;


// WEBPACK FOOTER //
// ./src/plugins/AudioManager.js